<template>
  <div :class="[wrpCls, 'right-content']">
    <!-- <a-icon type="loading" class="hover-sty video-content" @click="openNotification(total)" /> -->
    <div class="import-progress-bar" v-if="isShowMiniPorgress">
      <img src="@/assets/images/小火箭.png" alt="" />
      <a-progress
        strokeWidth="4"
        :format="() => `${this.importProgressCount}/${total}`"
        :percent="percentage"
        status="active"
      />
    </div>
    <a-popover content="数智人课堂" v-if="!firstLogin">
      <a-button
        type="link"
        style="color: rgba(0, 0, 0, 0.65)"
        class="hover-sty video-content"
        @click="$router.push({ name: 'digitalIntelligentHumanClassroomIndex' })"
      >
        <i-video theme="outline" size="21" :strokeWidth="3" strokeLinejoin="bevel" strokeLinecap="square" />
      </a-button>
    </a-popover>
    <!-- <a-popover content="产品手册" v-if="!firstLogin">
      <a-button
        type="link"
        style="color: rgba(0, 0, 0, 0.65)"
        class="hover-sty video-content"
        @click="
          openPdf(
            'https://metaworks-lingyunguang.obs.cn-north-4.myhuaweicloud.com/metaworks/platform/%E6%95%B0%E6%99%BA%E4%BA%BA%E7%9B%B4%E6%92%AD%E5%B9%B3%E5%8F%B0MetaWorks%E4%BA%A7%E5%93%81%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C.pdf'
          )
        "
      >
        <newspaper-folding theme="outline" size="21" :strokeWidth="3" strokeLinejoin="bevel" strokeLinecap="square" />
      </a-button>
    </a-popover> -->
    <MessageCenter v-if="!firstLogin" class="hover-sty" :messageTitle="messageTitle" :messageId="messageId" />
    <!-- <a-popover content="帮助中心">
    <HelpComponent class="hover-sty" />
     </a-popover> -->
    <avatar-dropdown class="hover-sty" :menu="showMenu" :current-user="currentUser" :class="prefixCls" />
    <!-- <select-lang :class="prefixCls" /> -->
    <SubscriptionModal v-model="showSubscriptionModal" />
  </div>
</template>

<script>
import AvatarDropdown from './AvatarDropdown'
import SelectLang from '@/components/SelectLang'
import MessageCenter from '@/components/GlobalHeader/components/MessageCenter.vue'
import HelpComponent from '@/components/GlobalHeader/components/HelpComponent.vue'
import { Video, NewspaperFolding } from '@icon-park/vue'
import { Progress, notification, Icon } from 'ant-design-vue'
import { EventBus } from '@/utils/event-bus'
import SubscriptionModal from './components/dialog.vue'

export default {
  name: 'RightContent',

  components: {
    AvatarDropdown,
    SelectLang,
    MessageCenter,
    HelpComponent,
    'i-video': Video,
    'newspaper-folding': NewspaperFolding,
    SubscriptionModal,
  },
  props: {
    prefixCls: {
      type: String,
      default: 'ant-pro-global-header-index-action',
    },
    isMobile: {
      type: Boolean,
      default: () => false,
    },
    topMenu: {
      type: Boolean,
      required: true,
    },
    theme: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showMenu: true,
      currentUser: {},
      messageTitle: '',
      messageId: '',
      heartBeatInterval: 5000, // 心跳间隔时间，单位为毫秒
      webSocket: null,
      heartBeatTimer: null,
      percentage: 0,
      progressControl: null,
      importProgressCount: 0,
      total: 0,
      isShowMiniPorgress: false,
      showSubscriptionModal: false,
      retrCount: 0,
      maxRetries: 5,
    }
  },
  computed: {
    firstLogin() {
      return this.$route.query.flag === 'first'
    },
    wrpCls() {
      return {
        'ant-pro-global-header-index-right': true,
        [`ant-pro-global-header-index-${this.isMobile || !this.topMenu ? 'light' : this.theme}`]: true,
      }
    },
    userInfo() {
      return this.$store.state.user.info
    },
  },
  mounted() {
    setTimeout(() => {
      this.currentUser = {
        name: this.$store.state.user.name,
      }
    }, 1500)

    /*********
     *消息通信有两种方案1.websocket，全双工通信，此方案已实现，受限于线上环境https证书尚未申请下来，wss没有支持域名，因此需要临时替代方案2来解决
     *方案2，sse，单工通信（http长连接）此方案已实现，
     * *************/
    this.initWebSocket() // websocket
    // this.createSseConnect()
  },
  methods: {
    onClick() {
      let tempobj = this.$store.state.permission.addRouters
      console.log(tempobj)
      // this.$router.push({ name: 'CreateBrand' })
    },
    // sse建立连接
    createSseConnect() {
      const self = this
      if (window.EventSource) {
        const eventSource = new EventSource(`${this.$sseUrl}/sse/createConnect?clientId=${this.userInfo.userName}`)
        eventSource.onmessage = (e) => {
          console.log('msg info:', e.data)
          self.handleMessage(JSON.parse(e.data))
        }
        eventSource.onopen = (e) => {
          console.log('已建立连接~')
        }
        eventSource.onerror = (e) => {
          if (e.readyState == EventSource.CLOSED) {
            console.log('连接关闭')
          } else if (eventSource.readyState == EventSource.CONNECTING) {
            console.log('正在重连')
          } else {
            console.log('error', e)
          }
        }
        eventSource.close = (e) => {
          console.log('连接关闭')
        }
      } else {
        console.log('你的浏览器不支持消息通信~')
      }
      console.log(' 测试 打印')
    },
    openNotification(sum) {
      this.total = sum
      if (this.isOpenNotification) return
      this.isOpenNotification = true

      const key = 'progress-notification-key'
      let currentPercentage = this.percentage

      // 创建通知实例
      let notificationInstance

      // 创建进度控制对象
      const progressControl = {
        update: (newPercentage) => {
          currentPercentage = Math.min(newPercentage, 100)
          if (notificationInstance) {
            // 更新通知内容
            notificationInstance.update({
              description: this.buildDescription(currentPercentage, sum),
            })
          }

          if (currentPercentage === 100) {
            setTimeout(() => {
              notification.close(key)
              this.isOpenNotification = false
            }, 2000)
          }
        },
        close: () => {
          notification.close(key)
          this.percentage = 0
          this.isOpenNotification = false
          EventBus.$emit('updateGoods')
          localStorage.setItem('isUploading', false)
          EventBus.$emit('isUploading', false)
        },
      }

      // 初始显示
      notificationInstance = notification.open({
        key,
        style: { padding: '14px' },
        message: this.buildTitle(),
        description: () => this.buildDescription(currentPercentage, sum),
        duration: null,
        getContainer: () => document.getElementById('app'),
        onClose: () => (this.isShowMiniPorgress = true),
      })

      return progressControl
    },

    buildTitle() {
      return this.$createElement(
        'div',
        {
          style: {
            fontSize: '14px',
            lineHeight: '22px',
            fontWeight: 500,
          },
        },
        '导入进度'
      )
    },

    buildDescription(percentage, sum) {
      return this.$createElement(
        'div',
        {
          style: {
            maxWidth: '400px',
            margin: '0 auto',
            borderRadius: '4px',
          },
        },
        [
          this.buildHeader(sum),
          this.$createElement(Progress, {
            props: {
              format: () => `${this.importProgressCount}/${sum}`,
              percent: this.percentage,
              status: this.percentage === 100 ? 'success' : 'active',
              strokeWidth: 4,
            },
          }),
        ]
      )
    },

    buildHeader(sum) {
      return this.$createElement('div', {
        style: {
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: '8px',
        },
      })
    },
    openSuccessNotification(successSum, total) {
      notification.open({
        style: {
          padding: '14px',
          border: '2px solid var(--notification-border-2, #FFF)',
          background: 'linear-gradient(98deg, #E8FFEA 0%, #FFF 100%)',
        },
        message: this.$createElement('div', {}, [
          this.$createElement(Icon, {
            style: {
              color: '#00B42A',
              marginRight: '8px',
            },
            props: {
              type: 'check-circle',
              theme: 'filled',
            },
          }),

          this.$createElement(
            'span',
            {
              style: {
                fontSize: '14px',
                lineHeight: '22px',
                fontWeight: 600,
              },
            },
            '导入成功'
          ),
        ]),
        duration: 2,
        description: () =>
          this.$createElement(
            'div',
            { style: { marginLeft: '24px' } },
            `商品批量导入已完成（${successSum}/${total}），导入商品可在商品中心查看${
              successSum < total ? '导入失败商品可前往消息中心查看详情' : ''
            }`
          ),
      })
    },
    openErrorNotification(successSum, total) {
      notification.open({
        style: {
          padding: '14px',
          border: '2px solid var(--notification-border-2, #FFF)',
          background: 'linear-gradient(98deg, #FFECE8 0%, #FFF 100%)',
        },
        message: this.$createElement('div', {}, [
          this.$createElement(Icon, {
            style: {
              color: '#F53F3F',
              marginRight: '8px',
            },
            props: {
              type: 'exclamation-circle',
              theme: 'filled',
            },
          }),

          this.$createElement(
            'span',
            {
              style: {
                fontSize: '14px',
                lineHeight: '22px',
                fontWeight: 600,
              },
            },
            '导入失败'
          ),
        ]),
        duration: 2,
        description: () =>
          this.$createElement(
            'div',
            { style: { marginLeft: '24px' } },
            `商品批量导入已完成（0/${total}），导入失败商品可前往消息中心查看详情`
          ),
      })
    },
    handleMessage(data) {
      this.messageTitle = data.messageTitle
      this.messageId = data.messageId
      this.$store.commit('SET_ALL_COUNT', data.newInfoCount)
      // console.log('测试打印', data)
      if (Object.keys(data).includes('importProgressFlag')) {
        localStorage.setItem('isUploading', data.importProgressFlag)
        EventBus.$emit('isUploading', data.importProgressFlag)
        this.isShowMiniPorgress = data.importProgressFlag
        if (data.importProgressFlag) {
          const message = JSON.parse(data.importProgress)
          this.total = message.importTotalCount
        }
      }
      if (data.importProgress && [0, 3].includes(data.messageType)) {
        const message = JSON.parse(data.importProgress)
        this.total = message.importTotalCount
        if (Object.keys(message).includes('success')) {
          if (this.progressControl) {
            this.progressControl.close()
          }
          this.progressControl = null
          this.importProgressCount = 0
          this.isShowMiniPorgress = false
          if (message.fail === message.total) {
            // const failList = message.failDetail
            this.openErrorNotification(message.success, message.total)
          } else {
            this.openSuccessNotification(message.success, message.total)
          }
          this.isShowMiniPorgress = false
          this.isUpploading = false
        } else {
          if (!this.progressControl && !this.isShowMiniPorgress) {
            this.progressControl = this.openNotification(message.importTotalCount)
          }
          localStorage.setItem('isUploading', true)
          EventBus.$emit('isUploading', true)
          this.importProgressCount = message.importProgressCount
          this.percentage = message.importProgressPercentage
        }
      }
      if (data.messageType === 1) {
      }
      if (data.messageType === 5) {
        const message = JSON.parse(data.platformExpireAlarm)
        if (message.hasOwnProperty('remainderDays') && message.remainderDays <= 7) {
          // this.openDialog()
          this.showSubscriptionModal = true
        }
      }
    },
    openImportNotification() {},
    initWebSocket() {
      /// ${this.$store.state.user.token}
      this.webSocket = new WebSocket(`${this.$websocketUrl}/websocket/${this.userInfo.userName}`)
      this.webSocket.onopen = () => {
        // 建立连接后开始发送心跳包
        this.startHeartBeat()
        if (this.$route.query.from && this.$route.query.from === 'login') {
          import('@/api/login.js').then((res) => {
            res.checkSubscriptionAPI()
          })
        }
      }
      this.webSocket.onmessage = (event) => {
        // 处理服务器发送的消息
        this.handleMessage(JSON.parse(event.data))
      }
      this.webSocket.onclose = () => {
        console.log('WebSocket连接已关闭')
        // 连接关闭后停止心跳包
        this.stopHeartBeat()
        this.retry()
        // 可根据需要重新连接
        // reconnect();
      }
      this.webSocket.onerror = () => {
        console.log('WebSocket连接出错')
        this.retry()
      }
    },
    startHeartBeat() {
      // 每隔一段时间发送心跳包
      this.heartBeatTimer = setInterval(() => {
        if (this.webSocket.readyState === this.webSocket.OPEN) {
          this.webSocket.send('hello,这是一个心跳包') // 发送心跳包
        }
      }, this.heartBeatInterval)
    },
    stopHeartBeat() {
      // 停止心跳包发送
      clearInterval(this.heartBeatTimer)
      this.heartBeatTimer = null
    },
    openPdf(url) {
      return new Promise((resolve, reject) => {
        let blob = null
        const xhr = new XMLHttpRequest()
        xhr.open('GET', url)
        xhr.responseType = 'blob'
        xhr.onload = () => {
          blob = xhr.response
          const blobob = new Blob([blob], { type: 'application/pdf;charset=utf-8' })
          const href = window.URL.createObjectURL(blobob)
          window.open(href, 'newWindow')
          resolve(url)
        }
        xhr.onerror = (e) => {
          reject(e)
        }
        xhr.send()
      })
    },
    retry() {
      console.log('websocket重连')
      if (this.retryCount >= this.maxRetries) {
        console.error('Max retries reached')
        this.options.onMaxRetries && this.options.onMaxRetries()
        return
      }

      this.retryCount++
      const delay = this.retryDelay * Math.pow(2, this.retryCount - 1) // 指数退避

      console.log(`Retry ${this.retryCount} in ${delay}ms`)

      setTimeout(() => {
        this.initWebSocket()
      }, delay)
    },
  },
}
</script>
<style lang="less" scoped>
.rightContent {
  position: relative;
}
.right-content {
  padding: 16px 24px;
  display: flex;
  align-items: center;
  // gap: 24px;
  height: 100%;
}
.video-content {
  display: inline-block;
  height: 100%;
  padding: 4px 12px 0;
  cursor: pointer;
  transition: all 0.3s;
}
.video-content:hover {
  background: rgba(0, 0, 0, 0.025);
}
.hover-sty:hover {
  color: #165dff !important;
}
.import-progress-bar {
  display: flex;
  width: 284px;
  height: 40px;
  border-radius: 8px;
  background: var(--bg-card-white, #fff);
  padding: 8px 16px;
  img {
    // width: 18px;
    height: 22px;
    line-height: 22px;
  }
  ::v-deep .ant-progress-outer {
    margin-right: calc(-3em - 8px);
    padding-right: calc(3em + 8px);
    .ant-progress-text {
      width: 3em;
    }
  }
}
</style>
